import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import _ from "underscore";
import moment from "moment/moment";
import I18n from 'lib/i18n/i18n';
import GA from 'lib/ga';
import Defer from 'lib/defer';
import WorthyApi from 'lib/api/worthyApi';
import {
    dollarsWithoutCents,
    isIphone,
    imageUrl,
    rootUrl,
    appDomain,
    chatBotKind,
    p13nServiceDecisions,
} from 'helpers/ApplicationHelper';
import {chatBotSaveLog, hvCuiSaveLog, setItemChatBot, updateBuyItNowPrice, updateShipmentMethodDetails} from 'actions/item';
import {schedulePickup, updateShipmentPreferences} from 'actions/shipment';
import BaseChatBot from "components/chatBot/baseChatBot";
import GoogleMapsMessage from 'components/chatBot/messageTypes/googleMapsMessage';
import GoogleMapsAutoComplete from 'components/chatBot/messageTypes/googleMapsAutoComplete';
import OneButton from 'components/chatBot/messageTypes/oneButton';
import SchedulePickupTime from 'components/chatBot/messageTypes/schedulePickupTime';
import UpdateShipmentMethodDetails from 'components/chatBot/messageTypes/updateShipmentMethodDetails';
import GoogleMUIAutoComplete from './messageTypes/googleMUIAutoComplete';
import WhatToDoNext from './messageTypes/whatToDoNext';
import {PopupSimilarItems} from 'components/popups/popupSimilarItems';
import SimilarItemsCui from "./messageTypes/similarItemsCui";

class ItemChatBot extends BaseChatBot {
    constructor(props) {
        super(props);

        this.fedexCalcDay = this.fedexCalcDay.bind(this);
        this.onAddressSelected = this.onAddressSelected.bind(this);
        this.generateShippingLabel = this.generateShippingLabel.bind(this);
        this.updateShipmentPreferences = this.updateShipmentPreferences.bind(this);
        this.schedulePickup = this.schedulePickup.bind(this);
        this.changeAddress = this.changeAddress.bind(this);
        this.onUpdateDetailsClick = this.onUpdateDetailsClick.bind(this);
        this.checkAvailablePickupSlots = this.checkAvailablePickupSlots.bind(this);
        this.observeOnceFlag = false;
    }

    componentDidMount() {
        this.props.setItemChatBot(this.props.item.id);

        super.componentDidMount();
        if (this.state.chatBotType === 'highValue')
            GA.funnelStage( this.props.item.estimation ? this.props.item.estimation.amount : null);
        window.addEventListener("hashchange", this.handleHashChange, false);
        if (window.location.hash === '#similar-items'){this.handleHashChange()}
    }

    componentWillReceiveProps(newProps) {
        super.componentWillReceiveProps(newProps);
        if(this.props.Session && !this.observeOnceFlag){
            this.observeOnceFlag = true;
            this.observer = new MutationObserver(this.onDOMMutation);
            this.observer.observe(document.getElementById('chat-bot'), { childList: true });
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.observer && this.observer.disconnect();
        delete this.observer;
        window.removeEventListener("hashchange", this.handleHashChange, false);
    }

    get objectId() {
        return this.props.item.id;
    }

    saveLog(message) {
        const itemId = this.props.item.id;
        if (this.state.chatBotType === 'highValue') {
            if (message.direction === '0') return;
            let system = message.direction === '1',
                key = message.key || message.toLowerCase().replace(/ /g, '_').replace(/'/g, ''),
                messageText;
            if (typeof message === 'object') {
                messageText = I18n.getString('itemPage::highValueEstimation::1::events::messages::chatBotMessage')
                    .replace(/{actor}|{version}|{message}/gi, match => {
                        switch (match) {
                            case '{actor}':
                                return system ? 'System' : 'Seller';
                            case '{version}':
                                return this.state.conversationVersion;
                            case '{message}':
                                return message.text;
                        }
                    });
            } else {
                messageText = message.replace(/<.*?>/g, '');
            }
            hvCuiSaveLog(itemId, this.state.conversationVersion, messageText, this.props.item.hvCuiLastMessageKey, system, key);
        } else {
            chatBotSaveLog(itemId, message, this.state.conversationVersion);
        }
    }

    textReplace(text) {
        text = super.textReplace(text);
        const fedexCalcDays = this.fedexCalcDay(3);
        text = text.replace(/{item_type}/g, this.props.item.item_type);
        text = text.replace(/{item_id}/g, this.props.item.id);
        text = text.replace(/{root_url}/g, rootUrl());
        text = text.replace(/{app_url}/g, 'https://' + appDomain());
        text = text.replace(/#{pickup_1_days}/g, fedexCalcDays[0].format('dddd'));
        text = text.replace(/#{pickup_1_days_date}/g, fedexCalcDays[0].format('MMM D YYYY'));
        text = text.replace(/#{pickup_2_days}/g, fedexCalcDays[1].format('dddd'));
        text = text.replace(/#{pickup_2_days_date}/g, fedexCalcDays[1].format("MMM D YYYY"));
        text = text.replace(/#{pickup_3_days}/g, fedexCalcDays[2].format('dddd'));
        text = text.replace(/#{pickup_3_days_date}/g, fedexCalcDays[2].format("MMM D YYYY"));
        if (text.indexOf('item_insurance_amount') !== -1) {
            text = text.replace(/#{item_insurance_amount}/g, dollarsWithoutCents(this.props.item.estimation.insurance));
        }
        if (this.state) {
            if (this.state.pickupPreferences.timeText) {
                text = text.replace(/#{schedule_time_text}/g, this.state.pickupPreferences.timeText);
            }
            if (this.state.formattedAddress) {
                text = text.replace(/#{schedule_pickup_address}/g, this.state.formattedAddress);
            }
        }
        // worthy-8976 show value in cui
        if ( this.props.item && this.props.item.estimation && this.props.item.estimation.total ) {
            let estimation = this.props.item.estimation.total
            text = text.replace(/#{estimation_range}/g,
                "<b>$" + dollarsWithoutCents(estimation.low) + "–$" + dollarsWithoutCents(estimation.high) + "</b>")
        }
        return text;
    }

    onDOMMutation(mutationRecords) {
        mutationRecords.forEach(record => {
            record.removedNodes.forEach(node => {
                node.classList.contains('non-fixed') && node.classList.remove('non-fixed-position');
            })
        })
    }

    buttonsClick(message, chosen) {
        super.buttonsClick(message, chosen);

        if (this.state.chatBotType === 'highValue') {
            this.saveLog(I18n.getString('itemPage::highValueEstimation::1::events::messages::button').replace('{buttonText}', chosen.text));
            GA.funnelStage( this.props.item.estimation ? this.props.item.estimation.amount : null);
        }
    }

    fedexCalcDay(days) {
        let i,
            resDay = moment(),
            resDays = [],
            currentResDay;
        for (i = 0; i < days; i++) {
            resDay = resDay.clone().add(1, 'd');
            currentResDay = parseInt(resDay.format('d'));
            while (currentResDay === 6 || currentResDay === 0) {
                resDay = resDay.add(1, 'd');
                currentResDay = parseInt(resDay.format('d'));
            }
            resDays[i] = resDay;
        }
        return resDays;
    }

    createDropOffLocations(pushLocationMessages = false) {
        let requests = this.props.item.shipment.locations.map((location, index) => {
            return new Promise((resolve) => {
                this.getAddressFromGoogle(location, index, resolve, pushLocationMessages);
            });
        });
        return requests;
    }

    onDropOffClick(message) {
        Promise.all(this.createDropOffLocations(true))
            .then(() => WorthyApi.handleDropOffSelected(this.props.item.id, this.state.dropOffLocations))
            .then(() => {
                let messageResponse = JSON.parse(this.textReplace(JSON.stringify(message['success']))),
                    afterResponse = (_.map(messageResponse, (message) => {
                        return message;
                    }));
                this.state.conversationFlow.splice(this.state.conversationPos, 0, ...afterResponse);
            });
    }

    onUpdateDetailsClick(message) {
        if (message.action) {
            let then = () => {
                let messageResponse = JSON.parse(this.textReplace(JSON.stringify(message[message['followUpMessage']]))),
                    afterResponse = (_.map(messageResponse, (message) => {
                        return message;
                    }));
                this.state.conversationFlow.splice(this.state.conversationPos, 0, ...afterResponse);
                this.updateConversation();
                this.setState({hideWaves: true});
            }
            if (message.action !== 'done') {
                this.props.updateShipmentMethodDetails(this.props.item.id, message.action).then(then);
                message.action !== 'update_pickup_details_time' ? this.setState({conversationPos: this.state.conversationFlow.length -1}) : null;
            } else {
                then();
                setTimeout(() => {
                    let el = document.querySelector('.our-reviews');
                    el && el.addEventListener('click', () => {
                        chatBotSaveLog(this.props.item.id, {key: 'our_reviews_clicked', direction: '1', type: 'message', text: 'our reviews link was clicked'} , this.state.conversationVersion);
                    });
                }, 500)
            }
        }
    }

    updateGIACertificate() {
        WorthyApi.updateGIACertificate(this.props.item.id)
    }

    handleContactAE() {
        WorthyApi.handleContactAE(this.props.item.id, 'call_seller')
    }

    getAddressFromGoogle(location, index, callback, pushLocationMessages) {
        let name = location.name;
        let address = location.address;
        WorthyApi.getAddressFromGoogle(address).then(results => {
            let address = results.data.results[0];
            let locationObj = {};
            locationObj[index] = {
                "name": name,
                "address": address.formatted_address
            };
            let dropOffLocations = Object.assign({}, this.state.dropOffLocations, locationObj);
            if (pushLocationMessages) {
                this.pushSellerMessage({
                    key: `message_drop_off_location_${index}`,
                    direction: 1,
                    type: 'google_map',
                    text: `${name}<br>${address.formatted_address}`,
                    lat: address.geometry.location.lat,
                    lng: address.geometry.location.lng
                }, index);
            }
            this.setState({dropOffLocations});
            callback();
        }, (data) => {
            //
        });
    }

    onAddressSelected(message, address) {
        GA.funnelStage( this.props.itemEstimationAmount);

        var compileAddress = {};

        _.each(address.address_components, (component) => {
            compileAddress[component.types[0]] = component.short_name;
        });

        this.removeFromConversation(message);
        this.setState({
            address: {
                street: (compileAddress.street_number ? compileAddress.street_number + ' ' : '') + (compileAddress.route ? compileAddress.route : ''),
                street2: this.state.address2,
                city: compileAddress.locality || compileAddress.sublocality_level_1 || compileAddress.administrative_area_level_3,
                state: compileAddress.administrative_area_level_1,
                zipcode: compileAddress.postal_code
            },
            formattedAddress: address.formatted_address
        });

        this.pushSellerMessage({
            key: 'message_address_provided',
            direction: "2",
            type: 'google_map',
            text: address.formatted_address,
            lat: address.geometry.location.lat(),
            lng: address.geometry.location.lng()
        });
    }

    getAddress(){
        return this.state.address === undefined ? this.props.item.bundle.address : {...this.state.address, address2: this.state.address2};
    }

    generateShippingLabel() {
        let shippingLabelDefer = Defer();
        let address = this.getAddress();
        let params = {
            address: {
                street: address.street,
                street2: address.address2,
                city: address.city,
                state: address.state,
                zipcode: address.zipcode
            },
            user: {
                first_name: this.props.Session.userData.last_name !== '' ? this.props.Session.userData.first_name : this.state.first_name,
                last_name: this.props.Session.userData.last_name !== '' ? this.props.Session.userData.last_name : this.state.last_name
            },
            auto_correct: true
        };

        this.props.generateShippingLabel(params, false).then(() => {
            shippingLabelDefer.resolve();
        });

        this.setState({haveShippingLabel: true});

        return shippingLabelDefer.promise;
    }

    updateShipmentPreferences() {
        if (this.state.shipmentPreferences !== null) {
            this.props.updateShipmentPreferences(this.props.item.id, this.state.shipmentPreferences);
            this.setState({conversationPos: this.state.conversationFlow.length - 1});
        }
    }

    schedulePickup() {
        const {pickupPreferences} = this.state
        if (pickupPreferences !== null) {
            let expectFullResponse = false;
            this.props.schedulePickup(this.props.item.id, pickupPreferences.readyTimestamp, pickupPreferences.companyCloseTime, this.state.dropOffLocations, expectFullResponse)
                .then((res) => {
                    if (pickupPreferences.earlySlot) {
                        this.saveLog(`User scheduled early pickup. readyTimestamp: ${pickupPreferences.readyTimestamp} companyCloseTime: ${pickupPreferences.companyCloseTime}`)
                    }
                    this.setState({pickupConfirmationNumber: !res.error ? res.payload.data.confirmation_number : 'error'})
                })
        }
    }

    hasPickupSlots(pickup) {
        const PICKUP_START_TIME = 11;
        const localTime = this.props.Session.userData.local_time;
        const cutOffTime = pickup.cut_off_time.split(':');
        let startDate = moment(pickup.date).set('hour', PICKUP_START_TIME).utcOffset(localTime)
        let endDate = moment(pickup.date).set('hour', cutOffTime[0]).set('minute', cutOffTime[1]).utcOffset(localTime)
        return endDate.isSameOrAfter(startDate.add(pickup.access_time, 's'));
    }

    checkAvailablePickupSlots(message) {
        let pickupAvailability = this.props.item.shipment.pickup_availability;
        let hasSlots = pickupAvailability && pickupAvailability.filter(pickup => this.hasPickupSlots(pickup)).length;
        let nextMessageKey =  pickupAvailability ? `has_${hasSlots ? '': 'no_'}slots` : 'fedex_error';
        let messageResponse = JSON.parse(this.textReplace(JSON.stringify(message[nextMessageKey]))),
            afterResponse = (_.map(messageResponse, (message) => {
                return message;
            }));
        this.state.conversationFlow.splice(this.state.conversationPos, 0, ...afterResponse);
    }

    changeAddress() {
        let conversationPos = _.indexOf(_.pluck(this.state.conversationFlow, 'key'), 'input_google_maps');
        let conversation = this.state.conversation;
        let changeAddressMessage = this.state.conversationConstMessages.message_address_change;
        if (parseInt(conversation[conversation.length - 1].direction) === 0) {
            conversation.splice(conversation.length - 1, 1);
        }
        this.setState({conversation, conversationPos});
        setTimeout(() => {
            this.pushSellerMessage(changeAddressMessage, false);
            clearTimeout(this.state.nextUpdateConversation);
            setTimeout(() => {
                this.setState({hideWaves: false});
                setTimeout(() => {
                    // this.pushToConversation(changeAddressMessage.response);
                    this.pushSellerMessage(changeAddressMessage.response, false);
                    this.updateConversation();
                }, parseInt(changeAddressMessage.response.time_to_show));
            }, 3000);
            this.updateLastMessages();
        })
    }

    scheduleAppointmentCallback() {
        super.scheduleAppointmentCallback();
        GA.funnelStage(this.props.item.estimation ? this.props.item.estimation.amount : null);
    }

    methodMessageHandler(message) {
        let stopUpdateConversation = false;
        switch (message.method) {
            case 'accept_sell_estimation':
                this.props.acceptEstimation(false);
                break;
            case 'generate_shipping_label':
                this.generateShippingLabel().then(() => {
                    this.setState({shippingLabelCreated: true});
                });
                break;
            case 'update_shipment_preferences':
                this.updateShipmentPreferences();
                break;
            case 'shipping_label_ready':
                if (this.state.shippingLabelCreated) {
                    break;
                }
                let waitForShippingLabel = () => {
                    if (this.state.shippingLabelCreated) {
                        this.updateConversation();
                    }
                    else {
                        setTimeout(() => {
                            waitForShippingLabel();
                        }, 400)
                    }
                };
                stopUpdateConversation = true;
                this.setState({hideWaves: false});
                waitForShippingLabel();
                break;
            case 'schedule_fedex_pickup':
                let waitForFedexConfirmationNumber = () => {
                    this.setState({hideWaves: false});
                    let pickupConfirmationNumber = this.state.pickupConfirmationNumber,
                        successOrFail = 'success';
                    if (pickupConfirmationNumber) {
                        if (pickupConfirmationNumber === 'error') {
                            successOrFail = 'fail'
                        }
                        let messageResponse = JSON.parse(this.textReplace(JSON.stringify(message[successOrFail]))),
                            afterResponse = (_.map(messageResponse, (message) => {
                                return message;
                            }));
                        this.state.conversationFlow.splice(this.state.conversationPos, 0, ...afterResponse);
                        this.setState({hideWaves: true});
                        this.updateConversation();
                    }
                    else {
                        setTimeout(() => {
                            waitForFedexConfirmationNumber();
                        }, 400)
                    }
                };
                stopUpdateConversation = true;
                Promise.all(this.createDropOffLocations(false)).then(() => this.schedulePickup());
                waitForFedexConfirmationNumber();
                break;
            case 'update_buy_it_now_price':
                this.props.updateBuyItNowPrice(this.props.item.id, this.state.buy_it_now_price, message, this.state.conversationVersion);
                break;
            case 'update_drop_off':
                stopUpdateConversation = true;
                this.onDropOffClick(message);
                break;
            case 'update_pickup_details':
            case 'update_drop_off_details':
                stopUpdateConversation = true;
                this.onUpdateDetailsClick(message);
                break;
            case 'update_gia_certificate':
                this.updateGIACertificate();
                break;
            case 'contact_ae':
                this.handleContactAE();
                break;
            case 'check_available_pickup_slots':
                this.checkAvailablePickupSlots(message);
                break;
            case 'continue':
                break;
            default:
                stopUpdateConversation = super.methodMessageHandler(message);
        }
        return stopUpdateConversation;
    }

    updateScrollPosition() {
        if (this.state.conversationPos < (this.state.chatBotType === 'highValue' ? 4 : 3)) return;
        super.updateScrollPosition();
    }

    updateConversation(message = null) {
        if (!message && typeof this.state.conversationFlow[this.state.conversationPos] == "undefined") return;

        if (this.props.item.workflow_state === 'shipping' && message && message.key.includes('message_welcome')) {
            let conversationPos = this.state.conversationPos + 2;
            this.setState({conversationPos});
        }
        message = super.updateConversation(message);

        if (message && message.key.includes('message_welcome'))
            setTimeout(() => {
                this.updatePositions('message message-text fade-in');
            });
    }

    setBubbleArrow(message) {
        if (this.state.chatBotType === 'standrad' && this.props.item.workflow_state === 'estimation_ready') return;
        super.setBubbleArrow(message)
    }

    renderMessage(message, i) {
        const messageDOM = super.renderMessage(message, i);
        if (messageDOM) return messageDOM;
        switch (message.type) {
            case 'google_map':
                return (<GoogleMapsMessage id="input-change-address" key={i} message={message}
                                           lastMessage={this.state.lastMessages.includes(i)}
                                           canChangeAddress={!(this.state.haveShippingLabel || this.state.isReturnedToCUI)}
                                           avatarTestMode={this.state.showAvatar}
                                           changeAddress={this.changeAddress}/>);
            case 'google_maps_auto_complete':
                isIphone() && document.getElementById('chat-bot').classList.add('non-fixed-child');
                return (<GoogleMapsAutoComplete id="input-address"
                                                // onFocus={this.onInputFocus.bind(this)}
                                                onBlur={this.onInputBlur.bind(this)} key={i} message={message}
                                                className={isIphone() ? "non-fixed" : ""}
                                                onAddressSelected={this.onAddressSelected}/>);
            case 'google_mui_auto_complete':
                return (<GoogleMUIAutoComplete id="input-address"
                                               key={i}
                                               message={message}
                                               itemId={this.props.item.id}
                                               onAddressSelected={this.onAddressSelected}/>);
            case 'one_button_phone':
                return (
                    <OneButton id="input-button-phone" key={i} message={message} />);
            case 'schedule_pickup_time':
                return (<SchedulePickupTime id="input-schedule-pickup-time" key={i} message={message}
                                            onClick={this.buttonsClick} updatePositions={this.updatePositions.bind(this)}/>);
            case 'update_pickup_details':
                return (<UpdateShipmentMethodDetails id="input-update-details" key={i} message={message}
                                             onClick={this.buttonsClick}  action='pickup'/>);
            case 'update_drop_off_details':
                return (<UpdateShipmentMethodDetails id="input-update-details" key={i} message={message}
                                            onClick={this.buttonsClick} action='drop_off'/>);
            case 'update_do_next_details':
                return (<WhatToDoNext id="input-update-details" key={i} message={message}
                                            onClick={this.buttonsClick}/>);
            case 'similar_items_cui':
                return (<SimilarItemsCui id="similar-items-cui" key={i} message={message} similarItems={this.props.item.similar_items} item={this.props.item} conversationVersion={this.state.conversationVersion}/>);
        }
    }

    csaImage() {
        return this.state.chatBotType === 'highValue' ?
            `url(${imageUrl('item/highValueEstimation/roy.png')})` : super.csaImage();
    }

    handleHashChange = () => {
        if (window.location.hash === '#similar-items'){
            const item = this.props.item;
            chatBotSaveLog(this.props.item.id, {key: 'popup_similar_items_link_clicked', direction: '1', type: 'message', text: 'Similar items link clicked'}, this.state.conversationVersion);
            chatBotSaveLog(this.props.item.id, {key: 'popup_similar_items_presented', direction: '1', type: 'message', text: `The following ${item.similar_items.length} items were displayed in the popup: ${item.similar_items.map((similarItem) => { return JSON.stringify({id: similarItem.id, sold_for: dollarsWithoutCents(similarItem.sold_for)})})}`}, this.state.conversationVersion);
            PopupSimilarItems.initPopup({item: item, onClose: this.closeSimilarItems});
        }
    }

    closeSimilarItems () {
        if (window.location.hash === '#similar-items') {
            history.replaceState("", document.title, window.location.pathname + window.location.search)
            history.go(-1)
        }
    }

    title(highValue) {
        return [p13nServiceDecisions.listingDraft, p13nServiceDecisions.lightListingDraft].includes(this.props.P13N.preShipmentUi) && !highValue ?
            I18n.getString(`listingPage::cuiTitle`) : I18n.getString(`itemPage::estimationReady::whatsNext::${highValue ? 'titleHighValue' : 'title'}`)
    }

    render() {
        const highValue = this.state.chatBotType === 'highValue',
            chatBotClass = highValue ? 'chat-bot-high-value' : '',
            csaClass = highValue ? 'csa-high-value' : '',
            title = this.title(highValue),
            errorTemplate = <ItemChatBot {...this.props} />;
        return super.render(chatBotClass, csaClass, title, errorTemplate);
    }
}

const mapStateToProps = (state) => {
    let item = state.Item;
    let user = state.ADO.user;
    const P13N = state.Personalized;
    const chatBotType = chatBotKind(item, user)
    return Object.assign(BaseChatBot.mapStateToPropsObject(state, chatBotType), {
        item,
        P13N,
    });
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign(BaseChatBot.mapDispatchToPropsObject(), {setItemChatBot, updateShipmentPreferences, schedulePickup, updateBuyItNowPrice, updateShipmentMethodDetails}), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemChatBot);
